module.exports = __webpack_public_path__ + "static/media/scb com.b3e703b8.png";